export const OBJECT_ASSOCIATIONS_CHANGED = 'OBJECT_ASSOCIATIONS_CHANGED';
export const OBJECT_PROPERTY_CHANGED = 'OBJECT_PROPERTY_CHANGED';